module.exports = __webpack_public_path__ + "static/img/news53.25a658a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news53.png
// module id = y9QW
// module chunks = 0